import { HttpProduct } from "../../../http";
import { SearchResponse } from "../../../types/SearchBar";
import {ProductCategoryFilter} from "../../../types/Category";

class SearchService {
  async getSuggestions(searchTerm: string): Promise<SearchResponse> {
    if (!searchTerm.trim()) {
      return { suggestions: [], totalResults: 0, searchTerm };
    }

    try {
        const filter: ProductCategoryFilter = {
            pagina: 1,
            tamanoPagina: 5
        }
      const response = await HttpProduct.getAllProducts(filter, searchTerm);
      
       const productSearchResults = response.paginaProductosDTO?.lista?.map((product: any) => ({
        id: product.id,
        name: product.nombre,
        price: product.precio,
        image: product.urlImagenPrincipal,
        sku: product.sku,
        type: 'product' as const
      })) || [];

      return {
        suggestions: productSearchResults,
        totalResults: response.paginaProductosDTO?.paginacion?.cantRecords || 0,
        searchTerm
      };

    } catch (error) {
      console.error('Search error:', error);
      return { suggestions: [], totalResults: 0, searchTerm };
    }
  }

  async getAllSearchResults(searchTerm: string, page: number = 1, pageSize: number = 20): Promise<any> {
      const filter: ProductCategoryFilter = {
          pagina: page,
          tamanoPagina: pageSize
      }
    return HttpProduct.getAllProducts(filter, searchTerm);
  }
}

export const searchService = new SearchService();














